import InlineEdit from './InlineEdit';

// export types
export type { InlineEditProps } from './InlineEdit';

// export components
export { InlineEdit };
export default InlineEdit;
